import { Injectable } from "@angular/core";
import { MICustomFunctionsParams } from "../../../models/fields/custom-function-params";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class QuantityUnitCode {
    constructor() {

    }




    setEveryoneDeclareUnitCode(customFunctionsObj: MICustomFunctionsParams) {

        const translateService = customFunctionsObj.injector.get(TranslateService);


        translateService.stream('selectItems').subscribe(translation => {
            const quantityUnitCodeEach = translation?.quantityUnitCodeEach;

            const additionalColumns: { [key: string]: string } = {};
            additionalColumns["MaslulCode"] = "6";

            const everyoneValue = {
                value: 1,
                label: quantityUnitCodeEach,
                additionalCode: null,
                additionalColumns: additionalColumns
            };

            const quantities = customFunctionsObj.formisForm.fields
                .find((x: FormlyFieldConfig) => x.key == 'quantities');

            if (quantities) {
                const declaredUnitCode = quantities.fieldGroup?.find((x: FormlyFieldConfig) => x.key == "declaredUnitCode");
                if (declaredUnitCode) {
                    declaredUnitCode.formControl?.setValue(everyoneValue);

                }
            }
        })



    }



}  
